import { RoyalMailProvider } from '~/lib/consts/providers';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import AlertWithIcon from '../../AlertWithIcon';
import { IsPreManifest } from '../../../lib/helpers/IsPreManifest';
import { P2GLink } from '@parcel2go/core-ui';
import useGoto from '~/hooks/use-goto';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';

interface props {
  item: SmartSendItemApiModel;
  close?: () => void;
}

export const ManifestCancellationMessage: React.FC<props> = (props) => {
  const { goTo } = useGoto();

  const onClick = () => {
    if (props.close) {
      props.close();
    }
    goTo(RoutingConstants.Manifests);
  };

  if (props.item?.BookingDetails?.Service?.Provider !== RoyalMailProvider) {
    return null;
  }

  if (IsPreManifest(props.item)) {
    return (
      <AlertWithIcon>
        If you would like to cancel this label, you can do this in the{' '}
        <P2GLink onClick={onClick}>manifests section</P2GLink>.
      </AlertWithIcon>
    );
  }

  return (
    <AlertWithIcon>
      If you would like to cancel this label, you will need to access your RoyalMail account to do this.
    </AlertWithIcon>
  );
};
